import React, {useRef} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {discountInterFace} from "./discountsInterface";
import Select5 from "../Generic/Select5";


const DiscountFreeFillApproveSelect = (props) => {

  const {discount, setDiscountProperty} = props;

  const approveObject = discount.approveOptions ? JSON.parse(discount.approveOptions) : {};
  const approveOptions = approveObject.options || [];

  const allOptions = [...approveOptions.map(option => ({
    value: option,
    label: option,
    noHover: true,
    canBeDeleted: true,
  })), {
    value: "Custom",
    label: "Add New",
    isNewInput: true,
  }];

  const onAddNew = (inputValue) => {
    setDiscountProperty("approveOptions", JSON.stringify({...approveObject,
      options: [...approveOptions, inputValue]
    }));
  }

  const onDeleteOption = (selectOption) => {
    setDiscountProperty("approveOptions", JSON.stringify({...approveObject,
      options: approveOptions.filter(optionValue => optionValue !== selectOption.value)
    }));
  }

  const onItemClick = (selectOption) => {
    console.log("selectOption", selectOption);
  }

  // const selectedItem = allOptions.find(item => item.value === feature.shippingTime);
  const selectedItem = null;

  return (
    <div className="padding-l8 padding-r16 text-none">
      <Select5 selectItems={allOptions}
               selectItemClick={onItemClick}
               onAddNew={onAddNew}
               onDeleteOption={onDeleteOption}
               selectedItem={selectedItem}
               placeholder={"Approval options"}
               className={"select5--units"}
               maxItems={6} />
    </div>
  )
};

DiscountFreeFillApproveSelect.propTypes = {
  discount: PropTypes.shape(discountInterFace).isRequired,
  setDiscountProperty: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {discountSections} = store.discountsState;
  return {
    discountSections,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountFreeFillApproveSelect)
